import _extends from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from 'react';
import { useTemplateOpener } from '@miro-site/ui-foundation';
export var TemplateButton = function TemplateButton(_ref) {
  var props = _extends({}, _ref);

  var _useTemplateOpener = useTemplateOpener(),
      setTemplateId = _useTemplateOpener.setTemplateId;

  var onClick = function onClick() {
    setTemplateId(props.templateId);
  };

  return /*#__PURE__*/React.cloneElement(props.children, {
    onClick: onClick
  });
};